import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'

export function AuthLayout() {
  const { isAuthenticated } = useAuthStore()
  if (isAuthenticated) return <Navigate to="/dashboard" replace />
  return (
    <div className="min-h-screen bg-bg-base flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-lg">
              <span className="text-white text-lg font-bold">N</span>
            </div>
            <span className="text-2xl font-bold text-text-primary">iNova Muhasebe</span>
          </div>
          <p className="text-text-muted text-sm">Türkiye Standartlarına Uygun Ön Muhasebe</p>
        </div>

        <Outlet />
      </div>
    </div>
  )
}
